import User from '../../type/User';

const userDisplayName = (user: Pick<User, 'username' | 'fullName'>) => user.fullName || user.username;

export default userDisplayName;
